import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import store from '@/store/store'

@Module
export default class AuthStore extends VuexModule {
  token?: string = localStorage.getItem('user-token') || undefined
  isNonSSO: boolean = false
  selectedRegion: string = ''

  @Mutation
  AUTH_SUCCESS (data: any) {
    console.log('AUTH_SUCCESS:store', data)
    if (data && data.token) {
      this.token = data.token
      localStorage.setItem('user-token', data.token)
      axios.defaults.headers.common = { Authorization: `Bearer ${this.token}` }
    }
  }

  @Mutation
  AUTH_ERROR () {
    if (this.token && this.token.length) {
      localStorage.removeItem('user-token')
      this.token = undefined
    }
  }

  @Mutation
  NON_SSO () {
    this.isNonSSO = true
  }

  @Mutation
  SET_SELECTED_REGION (region: string) {
    this.selectedRegion = region
  }

  @Action({ commit: 'AUTH_SUCCESS' })
  loginSuccess (data: any) {
    return data
  }

  @Action({ commit: 'AUTH_ERROR' })
  loginFailed () {
    return null
  }

  @Action({ commit: 'AUTH_ERROR' })
  async logout () {
    if (this.token) {
      await axios.post('/logout', { withCredentials: true })
    }
    return null
  }

  @Action({ commit: 'AUTH_SUCCESS' })
  async setSelectedMarket (payload: { key: string, selectedMarketLocale?: string }) {
    const response = await axios.post('/update-selected-market', { userKey: (this.getUserObj as any).key, key: payload.key, selectedMarketLocale: payload.selectedMarketLocale }, { withCredentials: true })
    return response ? response.data : null
  }

  @Action({ commit: 'SET_SELECTED_REGION' })
  async setSelectedRegion (region: string) {
    return region
  }

  @Action({ commit: 'AUTH_SUCCESS' })
  async fetchNewAccessToken () {
    const response = await axios.get('/token-refresh', { withCredentials: true })
    return response ? response.data : null
  }

  @Action({ commit: 'AUTH_ERROR' })
  async clearAccessToken () {
    return true
  }

  @Action({ commit: 'NON_SSO' })
  async setUserIsNonSSO () {
    return true
  }

  get isAuthenticated () {
    return !!this.token
  }

  get userIsNonSSO () {
    return this.isNonSSO
  }

  get getUserObj () {
    if (!this.token) {
      return null
    }
    return jwtDecode(this.token)
  }

  get getUserPermissions () {
    if (!this.token) {
      return []
    }
    const user: any = jwtDecode(this.token)
    return user ? user.permissions || [] : []
  }

  get getSelectedMarket () {
    if (!this.token) {
      return ''
    }
    const user: any = jwtDecode(this.token)
    return user ? user.selectedMarket || '' : ''
  }

  get getSelectedMarketLocale () {
    if (!this.token) {
      return ''
    }
    const user: any = jwtDecode(this.token)
    return user ? user.selectedMarketLocale || '' : ''
  }

  get getSelectedRegion () {
    // iterate through region maarkets array and find the region that matches the selected market by key
    const region = store.getters.getRegions.find((region: any) => region.markets.find((market: any) => market.key === store.getters.getSelectedMarket))
    return region ? region.name : ''
  }

  get getToken () {
    return this.token
  }
}
